import { Column, Flex, Row } from '@atom-web/micros'
import { ContactFill } from '@pyt/icons'
import * as PYTIcons from '@pyt/icons'
import { Badge, Pressable, Text } from '@pyt/micros'
import { createElement, useState } from 'react'
import Sticky from 'react-stickynode'

import isIxigoPartnersSite from '../utils/isIxigoPartnersSite'
import ContentWrapper from './ContentWrapper'

const DesktopFilter = ({
	filterOptions,
	isPressed,
	setIsPressed,
	clickAction,
}) => {
	const isIxigoPartnersSiteValue = isIxigoPartnersSite()

	const [filterSticky, setFilterSticky] = useState(false)
	const handleStateChange = status => {
		setFilterSticky(status.status === Sticky.STATUS_FIXED)
	}
	const handlePress = key => {
		if (isPressed.key === key) {
			setIsPressed({
				show: false,
			})
		} else {
			setIsPressed({
				show: true,
				key,
			})
		}
	}

	const BadgeWrapper = ({ isApplied, children, count }) =>
		isApplied ? (
			<Badge
				count={count}
				countProps={{
					right: 4,
					top: 4,
					backgroundColor: '#EF435D',
					fontWeight: 700,
				}}
			>
				{children}
			</Badge>
		) : (
			children
		)
	return (
		<Sticky
			onStateChange={handleStateChange}
			enabled={true}
			top={0}
			innerZ={99}
			backgroundColor="#fff"
		>
			<Flex
				css={{
					width: '100%',
					justifyContent: 'space-between',
					boxShadow: filterSticky
						? '0px 4px 18px rgba(31, 71, 62, 0.12)'
						: 'unset',
					backgroundColor: '#fff',
				}}
			>
				<Column
					css={{
						width: '100%',
					}}
				>
					<ContentWrapper css={{ paddingTop: '16px', paddingBottom: '16px' }}>
						<Row
							css={{
								width: '100%',
								justifyContent: 'space-between',
							}}
						>
							<Row
								css={{
									gap: 12,
									justifyContent: 'center',
									alignItems: 'center',
								}}
							>
								{filterOptions?.map((val, inx) => (
									<BadgeWrapper
										key={'filter' + inx}
										isApplied={val?.isApplied}
										count={val?.isApplied}
									>
										<Pressable
											height={36}
											paddingHorizontal={16}
											gap={5}
											justifyContent="center"
											alignItems={'center'}
											borderRadius={32}
											borderWidth={1}
											borderColor={val?.isApplied ? '#1895B3' : '#AAAAAA'}
											backgroundColor={val?.isApplied ? '#14809914' : '#fff'}
											flexDirection="row"
											onPress={() => handlePress(val?.key)}
										>
											{createElement(PYTIcons[val?.icon], {
												fill: val?.isApplied ? '#1895B3' : '#777777',
												width: '16px',
												height: '16px',
											})}
											<Text
												fontSize={15}
												fontWeight={600}
												lineHeight={20}
												color={val?.isApplied ? '#1895B3' : '#777777'}
											>
												{val?.name}
											</Text>
										</Pressable>
									</BadgeWrapper>
								))}
							</Row>
							<Column>
								<Pressable
									width={216}
									height={36}
									borderRadius={100}
									backgroundColor={
										isIxigoPartnersSiteValue ? '#FF4D01' : '#00B277'
									}
									alignItems="center"
									justifyContent="center"
									onPress={clickAction}
								>
									<Row
										css={{
											gap: 2,
										}}
									>
										<ContactFill width={20} height={20} fill="#FFD152" />
										<Text fontWeight={600} color="#fff">
											Need help? Talk to an expert
										</Text>
									</Row>
								</Pressable>
							</Column>
						</Row>
					</ContentWrapper>
				</Column>
			</Flex>
		</Sticky>
	)
}

export default DesktopFilter
